import React, { useState, useEffect } from 'react';
import { UserPlus, Save, AlertCircle, ShieldAlert, CalendarClock,MessageCircle, CheckCircle } from 'lucide-react';
import { perfilNoModulo } from '../../../utils/perfisDerivados';

const ProcessoSeletivoInscricaoInterna = () => {

    // 1. ESTADOS
    const [candidatos, setCandidatos] = useState([]);
    const [escalasDb, setEscalasDb] = useState([]); 
    const [gruposCargos, setGruposCargos] = useState([]); 
    const [isLoading, setIsLoading] = useState(true);
    
    // Estado para a Super Pop-up de Automação
    const [automacaoModal, setAutomacaoModal] = useState({
        isOpen: false,
        titulo: '',
        mensagem: '',
        onConfirm: null,
        onCancel: null
    });

    const [subAbaAtiva, setSubAbaAtiva] = useState('agendar');
    const [agendamentos, setAgendamentos] = useState({});
        
    const [candidatosSelecionados, setCandidatosSelecionados] = useState([]);
    const [bulkAgendamento, setBulkAgendamento] = useState({ local: '', data: '' });
        
    const [filterCpf, setFilterCpf] = useState('');
    const [filterNome, setFilterNome] = useState('');
    const [filterVaga, setFilterVaga] = useState('');
    const [filterStatusAgendar, setFilterStatusAgendar] = useState('TODOS'); 
    const [filterDataEntrevista, setFilterDataEntrevista] = useState(''); 
    const [filterLocal, setFilterLocal] = useState(''); 
    
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    const [formData, setFormData] = useState({
        nome_completo: '', data_nascimento: '', cpf: '', celular: '', email: '', cep: '', vaga_selecionada: '', regioes_disponiveis: '',
        verificacao_cpf: '', local_entrevista: '', data_entrevista: '', hora_entrevista: '' 
    });
    const [vagas, setVagas] = useState([]);
    const [loading, setLoading] = useState(false);
    const [mensagem, setMensagem] = useState(null);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalStep, setModalStep] = useState(1);
    const [candidatoSelecionado, setCandidatoSelecionado] = useState(null);

    const [vagaData, setVagaData] = useState({ 
    cargo: '', tipo_escala: '', nome_escala: '', folga: '', loja: '', data_exame: '', hora_exame: '08:00'
    });

    // 2. DADOS EXTERNOS E LÓGICA
    const userStr = localStorage.getItem('user');
    const user = userStr ? JSON.parse(userStr) : {};
    const role = perfilNoModulo(user.perfil, 'processoseletivo');
    const canAction = role === 'Admin' || role === 'Gerente' || role === 'RH' || role === 'ProcessoSeletivo' || role === 'Diretoria';
    const hasFixedLoja = user.loja && user.loja !== 'null' && user.loja.trim() !== '';

    const inputStyleModal = { width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #cbd5e1', outline: 'none', fontWeight: '600', color: '#1b0f2a', fontSize: '13px' };
    const labelStyleModal = { display: 'block', fontSize: '12px', fontWeight: '800', color: '#594769', marginBottom: '6px', textTransform: 'uppercase' };

    const isGTV = candidatoSelecionado?.LOCAL_ENTREVISTA === 'GTV';
    const gruposUnicos = [...new Set(gruposCargos.map(g => g.SUB_GRUPO_ABREV))].sort();
    const cargosFiltrados = gruposCargos.filter(gc => gc.SUB_GRUPO_ABREV === vagaData.grupo).map(gc => gc.NOME_CARGO_ABREV).sort();
    const formatHora = (h) => h ? h.substring(0, 5) : '--:--';
    const escalasFiltradas = escalasDb.filter(e => e.tipo_turno && vagaData.tipo_escala && e.tipo_turno.toUpperCase() === vagaData.tipo_escala.toUpperCase());
    const horariosEscalaUnicos = [...new Set(escalasFiltradas.map(e => `${formatHora(e.hora_entrada1)} às ${formatHora(e.hora_saida2)}`))].sort();

    const renderFolgaOptions = () => {
        const escala = vagaData.tipo_escala.toUpperCase();
        if (escala === '12X36') return <><option value="ÍMPAR">Ímpar</option><option value="PAR">Par</option></>;
        if (escala === 'PARTIME') return <><option value="SEG e TER">SEG e TER</option><option value="TER e QUA">TER e QUA</option><option value="QUA e QUI">QUA e QUI</option><option value="QUI e SEG">QUI e SEG</option></>;
        if (escala === '5X2') return <><option value="SEG e TER">SEG e TER</option><option value="TER e QUA">TER e QUA</option><option value="QUA e QUI">QUA e QUI</option><option value="QUI e SEG">QUI e SEG</option><option value="SEG e QUA">SEG e QUA</option><option value="SEG e QUI">SEG e QUI</option></>;
        return null;
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const token = localStorage.getItem('authToken');
                const headers = { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` };

                const [resCandidatos, resEscalas, resGrupos] = await Promise.all([
                    fetch('/api/processo-seletivo/candidatos', { headers }),
                    fetch('/api/processo-seletivo/escalas', { headers }), 
                    fetch('/api/processo-seletivo/grupos-cargos', { headers })
                ]);

                if (!resCandidatos.ok || !resEscalas.ok || !resGrupos.ok) throw new Error("Erro ao carregar os dados.");

                setCandidatos(await resCandidatos.json());
                setEscalasDb(await resEscalas.json());
                setGruposCargos(await resGrupos.json());
                setIsLoading(false);
            } catch (err) {
                setIsLoading(false);
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        const fetchVagas = async () => {
            try {
                const response = await fetch('/api/processo-seletivo/vagas-ativas');
                if (response.ok) {
                    const data = await response.json();
                    const cargosUnicos = [...new Set(data.map(v => v.CARGO))].sort();
                    setVagas(cargosUnicos);
                }
            } catch (error) {}
        };
        fetchVagas();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleCpfChange = (e) => {
        let value = e.target.value.replace(/\D/g, '').substring(0, 11);
        value = value.replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d{1,2})$/, '$1-$2');
        setFormData(prev => ({ ...prev, cpf: value }));
    };

    const handlePhoneChange = (e) => {
        let value = e.target.value.replace(/\D/g, '').substring(0, 11);
        if (value.length > 2) value = `(${value.substring(0, 2)}) ${value.substring(2)}`;
        if (value.length > 10) value = `${value.substring(0, 10)}-${value.substring(10)}`;
        setFormData(prev => ({ ...prev, celular: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMensagem(null);
        
        // Unificando Data e Hora da Entrevista
        let data_hora_entrevista_formatada = null;
        if (formData.verificacao_cpf === 'SIM') {
            if (!formData.local_entrevista || !formData.data_entrevista || !formData.hora_entrevista) {
                setMensagem({ tipo: 'erro', texto: 'Local, Data e Horário da Entrevista são obrigatórios.' });
                return;
            }
            data_hora_entrevista_formatada = `${formData.data_entrevista} ${formData.hora_entrevista}`;
        }

        // Unificando Data e Hora do Exame
        let data_hora_exame_formatada = null;
        if (vagaData.data_exame && vagaData.hora_exame) {
            data_hora_exame_formatada = `${vagaData.data_exame} ${vagaData.hora_exame}:00`;
        }

        const cpfLimpoFront = formData.cpf.replace(/\D/g, '');
        const celularLimpoFront = formData.celular.replace(/\D/g, '');

        // Função interna que fará o disparo real para o Backend
        const executarSubmissao = async (enviarMensagem) => {
            setLoading(true);
            setAutomacaoModal({ ...automacaoModal, isOpen: false });

            try {
                const token = localStorage.getItem('authToken');
                const response = await fetch('/api/processo-seletivo/inscricao-interna', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                    body: JSON.stringify({ 
                        ...formData, 
                        ...vagaData, 
                        cpf: cpfLimpoFront, 
                        celular: celularLimpoFront, 
                        data_hora_entrevista: data_hora_entrevista_formatada,
                        data_hora_exame: data_hora_exame_formatada,
                        enviar_automacao: enviarMensagem // <-- Nossa trava está aqui!
                    })
                });
                
                const data = await response.json();
                
                if (response.ok) {
                    setMensagem({ tipo: 'sucesso', texto: data.message });
                    setFormData({ nome_completo: '', data_nascimento: '', cpf: '', celular: '', email: '', cep: '', vaga_selecionada: '', regioes_disponiveis: '', verificacao_cpf: '', local_entrevista: '', data_entrevista: '', hora_entrevista: '' });
                } else { 
                    setMensagem({ tipo: 'erro', texto: data.message }); 
                }
            } catch (error) { 
                setMensagem({ tipo: 'erro', texto: "Erro de conexão." }); 
            }
            setLoading(false);
        };

        // Lógica de abertura do Modal
        if (formData.verificacao_cpf === 'SIM') {
            setAutomacaoModal({
                isOpen: true,
                titulo: 'Aprovar e Enviar Comunicação? 📧',
                mensagem: 'Deseja disparar as automações (E-mail/WhatsApp) com os dados de agendamento para este candidato interno?',
                onConfirm: () => executarSubmissao(true),
                onCancel: () => executarSubmissao(false)
            });
        } else {
            // Se for reprovação (NÃO), não precisa de modal, apenas salva direto e silencioso
            executarSubmissao(false);
        }
    };

    const inputStyle = { width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #cbd5e1', outline: 'none', fontWeight: '600', fontSize: '14px', boxSizing: 'border-box' };
    const labelStyle = { display: 'block', fontSize: '13px', fontWeight: '800', color: '#475569', marginBottom: '6px', textTransform: 'uppercase' };

    return (
        <div style={{ animation: 'fadeIn 0.3s', maxWidth: '850px', margin: '0 auto' }}>
            <div style={{ marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{ backgroundColor: '#ffe4e6', padding: '12px', borderRadius: '12px', color: '#e11d48' }}><UserPlus size={28} /></div>
                <div>
                    <h2 style={{ fontSize: '24px', fontWeight: '900', color: '#0f172a', margin: 0 }}>Cadastro Interno</h2>
                    <p style={{ color: '#64748b', fontSize: '14px', margin: 0 }}>Cadastre candidatos manuais com verificação de histórico.</p>
                </div>
            </div>

            {mensagem && (
                <div style={{ backgroundColor: mensagem.tipo === 'sucesso' ? '#ecfdf5' : '#fef2f2', border: `1px solid ${mensagem.tipo === 'sucesso' ? '#a7f3d0' : '#fecaca'}`, padding: '16px', borderRadius: '12px', marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '12px', color: mensagem.tipo === 'sucesso' ? '#065f46' : '#991b1b' }}>
                    <AlertCircle size={20} /><span style={{ fontWeight: '700' }}>{mensagem.texto}</span>
                </div>
            )}

            <form onSubmit={handleSubmit} style={{ backgroundColor: '#fff', padding: '32px', borderRadius: '16px', border: '1px solid #e2e8f0', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
                
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px', marginBottom: '32px' }}>
                    <div><label style={labelStyle}>Nome Completo</label><input required type="text" name="nome_completo" value={formData.nome_completo} onChange={handleChange} style={inputStyle} /></div>
                    <div><label style={labelStyle}>Data de Nascimento</label><input required type="date" name="data_nascimento" value={formData.data_nascimento} onChange={handleChange} style={inputStyle} /></div>
                    <div><label style={labelStyle}>CPF</label><input required type="text" name="cpf" value={formData.cpf} onChange={handleCpfChange} style={inputStyle} maxLength="14" /></div>
                    <div><label style={labelStyle}>Celular (WhatsApp)</label><input required type="text" name="celular" value={formData.celular} onChange={handlePhoneChange} style={inputStyle} maxLength="15" /></div>
                    <div><label style={labelStyle}>E-mail</label><input required type="email" name="email" value={formData.email} onChange={handleChange} style={inputStyle} /></div>
                    <div><label style={labelStyle}>CEP</label><input required type="text" name="cep" value={formData.cep} onChange={handleChange} style={inputStyle} maxLength="9" /></div>
                </div>

                <div style={{ borderTop: '1px solid #f0e2f0', margin: '24px 0' }}></div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}><ShieldAlert size={20} color="#f63bd7" /><h3 style={{ fontSize: '18px', fontWeight: '800', margin: 0 }}>Vaga e Histórico</h3></div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginBottom: '32px' }}>
                    <div><label style={labelStyle}>Vaga Pretendida</label><select required name="vaga_selecionada" value={formData.vaga_selecionada} onChange={handleChange} style={{...inputStyle, backgroundColor: '#f8fafc'}}><option value="">Selecione...</option>{vagas.map((v, i) => <option key={i} value={v}>{v}</option>)}</select></div>
                    <div><label style={labelStyle}>Região Disponível</label><select required name="regioes_disponiveis" value={formData.regioes_disponiveis} onChange={handleChange} style={{...inputStyle, backgroundColor: '#f8fafc'}}><option value="">Selecione...</option><option value="Grande Vitória">Grande Vitória</option><option value="Guarapari">Guarapari</option></select></div>
                    <div style={{ backgroundColor: '#ffe4e6', padding: '12px', borderRadius: '12px', border: '1px solid #fbb6c4' }}>
                        <label style={{...labelStyle, color: '#8a1e8a'}}>Histórico Aprovado?</label>
                        <div style={{ display: 'flex', gap: '16px', marginTop: '8px' }}>
                            <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', fontWeight: '700', color: '#166534' }}><input type="radio" name="verificacao_cpf" value="SIM" checked={formData.verificacao_cpf === 'SIM'} onChange={handleChange} style={{ width: '18px', height: '18px', accentColor: '#10b981' }} /> Sim</label>
                            <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', fontWeight: '700', color: '#991b1b' }}><input type="radio" name="verificacao_cpf" value="NÃO" checked={formData.verificacao_cpf === 'NÃO'} onChange={handleChange} style={{ width: '18px', height: '18px', accentColor: '#e11d48' }} /> Não</label>
                        </div>
                    </div>
                </div>

                {formData.verificacao_cpf === 'SIM' && (
                    <div style={{ animation: 'fadeIn 0.3s', backgroundColor: '#ffe4e6', padding: '24px', borderRadius: '16px', border: '1px solid #fbb6c4', marginBottom: '32px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px', color: '#e11d48' }}>
                            <CalendarClock size={20} />
                            <h3 style={{ margin: '0 0 8px 0', fontSize: '22px', fontWeight: '900', color: '#0f172a' }}>Confirmação de Vaga</h3>
                        </div>
                        <p style={{ margin: '0 0 24px 0', color: '#80648b', fontSize: '14px' }}>
                            Confirme os dados para a contratação de <strong style={{color: '#0f172a'}}>{formData.nome_completo || 'Candidato'}</strong>.
                        </p>
                        
                        <div style={{ backgroundColor: '#f8fafc', padding: '16px', borderRadius: '12px', border: '1px solid #e2e8f0', marginBottom: '24px' }}>
                            <h4 style={{ margin: '0 0 16px 0', fontSize: '15px', fontWeight: '800', color: '#b116f9' }}>📝 Dados Pessoais Editáveis</h4>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '16px' }}>
                                <div>
                                    <label style={labelStyleModal}>Nome</label>
                                    <input type="text" name="nome_completo" value={formData.nome_completo} onChange={handleChange} style={inputStyleModal} />
                                </div>
                                <div>
                                    <label style={labelStyleModal}>CPF</label>
                                    <input type="text" name="cpf" value={formData.cpf} onChange={handleCpfChange} style={inputStyleModal} maxLength="14" />
                                </div>
                                <div>
                                    <label style={labelStyleModal}>E-mail</label>
                                    <input type="email" name="email" value={formData.email} onChange={handleChange} style={inputStyleModal} />
                                </div>
                                <div>
                                    <label style={labelStyleModal}>Celular</label>
                                    <input type="text" name="celular" value={formData.celular} onChange={handlePhoneChange} style={inputStyleModal} maxLength="15" />
                                </div>
                            </div>                                
                            
                            <h4 style={{ margin: '16px 0 16px 0', fontSize: '15px', fontWeight: '800', color: '#b116f9' }}>💼 Detalhes da Contratação</h4>
                            
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
                                {!hasFixedLoja && (
                                    <div>
                                        <label style={labelStyleModal}>Loja de Atuação</label>
                                        <select 
                                            value={vagaData.loja} 
                                            onChange={e => setVagaData({...vagaData, loja: e.target.value})} 
                                            disabled={isGTV} 
                                            style={{...inputStyleModal, border: '2px solid #6516f9', backgroundColor: isGTV ? '#f6f1f9' : '#fff', cursor: isGTV ? 'not-allowed' : 'auto'}}
                                        >
                                            <option value="">Selecione a Loja...</option><option value="ANV">ANV</option><option value="BVV">BVV</option><option value="FER">FER</option><option value="GTV">GTV</option><option value="MAL">MAL</option><option value="MOX">MOX</option><option value="PCI">PCI</option><option value="PCS">PCS</option><option value="RDP">RDP</option><option value="SED">SED</option><option value="SVV">SVV</option><option value="VEL">VEL</option><option value="VSH">VSH</option>
                                        </select>
                                    </div>
                                )}

                                <div><label style={labelStyleModal}>1. Grupo do Cargo</label><select value={vagaData.grupo} onChange={e => setVagaData({...vagaData, grupo: e.target.value, cargo: ''})} style={inputStyleModal}><option value="">Selecione...</option>{gruposUnicos.map((g, i) => <option key={i} value={g}>{g}</option>)}</select></div>
                                <div><label style={labelStyleModal}>2. Cargo Contratado</label><select value={vagaData.cargo} onChange={e => setVagaData({...vagaData, cargo: e.target.value})} disabled={!vagaData.grupo} style={{...inputStyleModal, backgroundColor: vagaData.grupo ? '#fff' : '#f7f1f9'}}><option value="">Selecione...</option>{cargosFiltrados.map((c, i) => <option key={i} value={c}>{c}</option>)}</select></div>
                                <div><label style={labelStyleModal}>Tipo de Escala</label><select value={vagaData.tipo_escala} onChange={e => setVagaData({...vagaData, tipo_escala: e.target.value, nome_escala: '', folga: ''})} style={inputStyleModal}><option value="">Selecione...</option><option value="12X36">12x36</option><option value="5X2">5x2</option><option value="PARTIME">PARTIME</option></select></div>
                                <div><label style={labelStyleModal}>Horário da Escala</label><select value={vagaData.nome_escala} onChange={e => setVagaData({...vagaData, nome_escala: e.target.value})} disabled={!vagaData.tipo_escala} style={{...inputStyleModal, backgroundColor: vagaData.tipo_escala ? '#fff' : '#f7f1f9'}}><option value="">{vagaData.tipo_escala ? 'Selecione o Horário...' : 'Selecione o Tipo 1º'}</option>{horariosEscalaUnicos.map((h, i) => <option key={i} value={h}>{h}</option>)}</select></div>
                                <div><label style={labelStyleModal}>Dia(s) de Folga</label><select value={vagaData.folga} onChange={e => setVagaData({...vagaData, folga: e.target.value})} disabled={!vagaData.tipo_escala} style={{...inputStyleModal, backgroundColor: vagaData.tipo_escala ? '#fff' : '#f7f1f9'}}><option value="">{vagaData.tipo_escala ? 'Selecione a Folga...' : 'Selecione o Tipo 1º'}</option>{renderFolgaOptions()}</select></div>
                                <div><label style={labelStyleModal}>Data do Exame</label><input type="date" value={vagaData.data_exame} onChange={e => setVagaData({...vagaData, data_exame: e.target.value})} style={inputStyleModal} /></div>
                                <div><label style={labelStyleModal}>Hora do Exame</label><input type="time" value={vagaData.hora_exame} onChange={e => setVagaData({...vagaData, hora_exame: e.target.value})} style={inputStyleModal} /></div>
                            </div>
                        </div>

                        {/* --- SEÇÃO DE DATA E HORA AQUI --- */}
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px' }}>
                            <div>
                                <label style={{...labelStyle, color: '#5d129a'}}>Local da Entrevista</label>
                                <select required name="local_entrevista" value={formData.local_entrevista} onChange={(e) => setFormData({...formData, local_entrevista: e.target.value})} style={{...inputStyle, border: '2px solid #cbd5e1'}}><option value="">Escolha o Local...</option><option value="GTV">GTV</option><option value="MOX">MOX</option><option value="PCI">PCI</option><option value="SED">SED</option><option value="VEL">VEL</option></select>
                            </div>
                            
                            <div>
                                <label style={{...labelStyle, color: '#5d129a'}}>Data da Entrevista</label>
                                <input 
                                    required 
                                    type="date" 
                                    name="data_entrevista" 
                                    value={formData.data_entrevista} 
                                    onChange={handleChange} 
                                    style={{...inputStyle, border: '2px solid #cbd5e1'}} 
                                />
                            </div>

                            <div>
                                <label style={{...labelStyle, color: '#5d129a'}}>Horário da Entrevista</label>
                                <div style={{ display: 'flex', gap: '12px' }}>
                                    <button
                                        type="button"
                                        onClick={() => setFormData({ ...formData, hora_entrevista: '09:00:00' })}
                                        style={{
                                            flex: 1, padding: '10px', borderRadius: '8px', cursor: 'pointer', fontWeight: '800', fontSize: '14px', transition: 'all 0.2s',
                                            backgroundColor: formData.hora_entrevista === '09:00:00' ? '#e11d48' : '#fff',
                                            color: formData.hora_entrevista === '09:00:00' ? '#fff' : '#475569',
                                            border: formData.hora_entrevista === '09:00:00' ? '2px solid #e11d48' : '1px solid #cbd5e1'
                                        }}
                                    >
                                        09:00
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => setFormData({ ...formData, hora_entrevista: '14:00:00' })}
                                        style={{
                                            flex: 1, padding: '10px', borderRadius: '8px', cursor: 'pointer', fontWeight: '800', fontSize: '14px', transition: 'all 0.2s',
                                            backgroundColor: formData.hora_entrevista === '14:00:00' ? '#e11d48' : '#fff',
                                            color: formData.hora_entrevista === '14:00:00' ? '#fff' : '#475569',
                                            border: formData.hora_entrevista === '14:00:00' ? '2px solid #e11d48' : '1px solid #cbd5e1'
                                        }}
                                    >
                                        14:00
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <button type="submit" disabled={loading} style={{ backgroundColor: formData.verificacao_cpf === 'NÃO' ? '#e11d48' : '#059669', color: '#fff', border: 'none', padding: '14px 28px', borderRadius: '8px', fontWeight: '800', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Save size={20} />{loading ? 'Processando...' : (formData.verificacao_cpf === 'NÃO' ? 'Registrar Reprovação' : 'Salvar')}
                    </button>
                </div>
            </form>
            {/* ====== SUPER POP-UP DE AUTOMAÇÃO ====== */}
            {automacaoModal.isOpen && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(15, 23, 42, 0.85)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 99999, padding: '20px', animation: 'fadeIn 0.2s' }}>
                    <div style={{ backgroundColor: '#fff', borderRadius: '24px', width: '100%', maxWidth: '700px', padding: '48px 32px', textAlign: 'center', boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)' }}>
                        
                        <div style={{ backgroundColor: '#fef3c7', width: '96px', height: '96px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px auto' }}>
                            <MessageCircle size={48} color="#d97706" />
                        </div>
                        
                        <h2 style={{ fontSize: '32px', fontWeight: '900', color: '#0f172a', marginBottom: '16px' }}>
                            {automacaoModal.titulo}
                        </h2>
                        
                        <p style={{ fontSize: '18px', color: '#475569', marginBottom: '40px', lineHeight: '1.6' }}>
                            {automacaoModal.mensagem}
                        </p>
                        
                        <div style={{ display: 'flex', gap: '20px', justifyContent: 'center' }}>
                            <button 
                                onClick={() => automacaoModal.onCancel()} 
                                style={{ padding: '16px 24px', fontSize: '18px', borderRadius: '12px', border: '2px solid #e2e8f0', backgroundColor: '#f8fafc', color: '#64748b', fontWeight: '800', cursor: 'pointer', transition: 'all 0.2s', flex: 1 }}
                            >
                                Não, apenas salvar
                            </button>
                            
                            <button 
                                onClick={() => automacaoModal.onConfirm()} 
                                style={{ padding: '16px 24px', fontSize: '18px', borderRadius: '12px', border: 'none', background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)', color: '#fff', fontWeight: '900', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', boxShadow: '0 10px 15px -3px rgba(16, 185, 129, 0.3)', flex: 1 }}
                            >
                                <CheckCircle size={24} /> Sim, Enviar Mensagem
                            </button>
                        </div>

                        <button 
                            onClick={() => setAutomacaoModal({ ...automacaoModal, isOpen: false })} 
                            style={{ marginTop: '32px', background: 'none', border: 'none', color: '#94a3b8', textDecoration: 'underline', cursor: 'pointer', fontSize: '15px', fontWeight: '600' }}
                        >
                            Cancelar tudo e fechar
                        </button>

                    </div>
                </div>
            )}
        </div>
    );
};

export default ProcessoSeletivoInscricaoInterna;